const Loader = () => {
	return (
		<div className="loader">
			<div className="waterfall">
				<div></div>
				<div></div>
				<div></div>
				<div></div>
				<div></div>
			</div>
		</div>
	);
};

export default Loader;
